import getMultiple from './get-multiple';
import xAPIStatement from './xapi-statement';

const actions = {
	getMultiple,
	xAPIStatement,
};

export default actions;
